export const GLOBALS = {
  TESTING: false,
  BUILD_ENV: "dev",
  NAME: "Files",
  URL: "https://files.cinesenddev.com",
  API_URL: "https://api.cinesenddev.com/api",
  FILES_URL: "https://files.cinesenddev.com",
  ACCOUNTS_URL: "https://accounts.cinesenddev.com",
  PUSHER_KEY: "0edd289b7933fc036740",
  PUSHER_DEBUG: false,
  AWS_ACCELERATED_ENDPOINT: "https://cinesend-dev.s3-accelerate.amazonaws.com"
}
